import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import AppSidebar from '../components/AppSidebar';
import FloatingHomeButton from '../components/FloatingHomeButton';

export default function MainLayout() {
    const location = useLocation();
    const isLauncher = location.pathname === '/' || location.pathname === '/launcher';

    return (
        <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
            <Header />
            <div className="flex-1 flex overflow-hidden relative">
                {!isLauncher && <AppSidebar />}

                <main className="flex-1 overflow-y-auto relative">
                    <Suspense fallback={<div className="flex justify-center p-10">Carregando...</div>}>
                        <Outlet />
                    </Suspense>
                </main>
            </div>
        </div>
    );
}
